import { cn } from "@/lib/cn";
import { brand } from "@/brand";

/** The brand mark: three rising candlesticks, the last in saffron (research leading to investing). */
export function Logo({ className, withName = true }: { className?: string; withName?: boolean }) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      {/* width/height too, so the mark stays small even before the stylesheet applies */}
      <svg viewBox="0 0 32 32" width="28" height="28" className="size-7 shrink-0" aria-hidden>
        <rect width="32" height="32" rx="7.5" fill="#1f56e0" />
        <path d="M8.5 14v12" stroke="#f4f1ea" strokeWidth="1.8" strokeLinecap="round" />
        <rect x="5.5" y="16" width="6" height="8" rx="1.4" fill="#f4f1ea" />
        <path d="M16 9v14" stroke="#f4f1ea" strokeWidth="1.8" strokeLinecap="round" />
        <rect x="13" y="11" width="6" height="10" rx="1.4" fill="#f4f1ea" />
        <path d="M23.5 4.5v14" stroke="#e8952a" strokeWidth="1.8" strokeLinecap="round" />
        <rect x="20.5" y="6.5" width="6" height="10" rx="1.4" fill="#e8952a" />
      </svg>
      {withName ? <span className="text-[15px] font-semibold tracking-tight text-fg">{brand.name}</span> : null}
    </span>
  );
}
